export function unescapeLegacyEncodedHtml(value: string): string {
  const hasRealTags = /<[a-z][\s\S]*>/i.test(value)
  const hasEscapedTags = /&lt;\s*\/?\s*[a-z]/i.test(value) || /&#0*60;|&#x0*3c;/i.test(value)
  if (hasRealTags || !hasEscapedTags) {
    return value
  }

  return value
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#0*39;|&#x0*27;|&apos;|&#39;/gi, "'")
    .replace(/&nbsp;/gi, ' ')
    .replace(/&#0*60;/gi, '<')
    .replace(/&#x0*3c;/gi, '<')
    .replace(/&#0*62;/gi, '>')
    .replace(/&#x0*3e;/gi, '>')
}

export function stripHtmlToPlainText(value: string | null | undefined): string {
  if (!value) return ''

  const withRealTags = unescapeLegacyEncodedHtml(value)
  const withoutTags = withRealTags.replace(/<[^>]*>/g, ' ')
  const decoded = withoutTags
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")

  return decoded.replace(/\s+/g, ' ').trim()
}

export function htmlHasVisibleText(value: string | null | undefined): boolean {
  return stripHtmlToPlainText(value) !== ''
}

export function editorHtmlToInline(html: string): string {
  const trimmed = html.trim()
  if (trimmed === '' || trimmed === '<p></p>') {
    return ''
  }

  return trimmed
    .replace(/<\/p>\s*<p>/gi, '<br>')
    .replace(/<\/?p>/gi, '')
    .trim()
}

export function isEmptyEditorHtml(html: string | null | undefined): boolean {
  if (!html) return true
  const compact = html.replace(/\s+/g, '').toLowerCase()
  return compact === '' || compact === '<p></p>' || compact === '<p><br></p>' || compact === '<p><br/></p>'
}